export const JSONsafeParse = <T>(str: string) => {
  if (!str) return;

  try {
    return JSON.parse(str) as T;
  } catch (e) {
    console.error(`Error ${str} features`, e);
  }
};
